import { useParams } from "react-router-dom";
import Layout from "../layout";
import { HelpersProvider } from "@my-helpers/common";
import HelperView from "./helper";
import HelpersView from "./helpers";
import { useState } from "react";

const Helpers = () => {
    const { id } = useParams<{ id: string }>();
    const [creating, setCreating] = useState<boolean>(false);

	return (
		<Layout>
			<HelpersProvider helperId={id} >
                {
                    id ? 
                    <HelperView creating={creating} setCreating={setCreating} /> :
                    <HelpersView creating={creating} setCreating={setCreating} />
                }
			</HelpersProvider>
		</Layout>
	);
};

export default Helpers;